
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "arrow-empty-right.icon",
  "use": "arrow-empty-right.icon-usage",
  "viewBox": "0 0 15 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 25\" id=\"arrow-empty-right.icon\"><g id=\"arrow-empty-right.icon_Fichiers-Mensuels\" stroke=\"none\" stroke-width=\"1\"><g id=\"arrow-empty-right.icon_Fichiers-mensuels-2016\" transform=\"translate(-1309 -927)\"><g id=\"arrow-empty-right.icon_Group-6\" transform=\"translate(116 915)\"><path id=\"arrow-empty-right.icon_Fill-1\" transform=\"scale(-1 1) rotate(90 0 -1175.737)\" d=\"M1210.737 17.263l-10.5 10.5-10.5-10.5-2 1.974 12.5 12.5 12.5-12.5z\" /></g></g></g></symbol>"
});
    sprite.add(symbol);
    export default class ArrowEmptyRightIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="arrow-empty-right.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/arrow-empty-right.icon.svg